import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { dispatchEvent } from 'src/helpers/tagManager'
import { FormattedMessage } from 'react-intl'

import {
  LowConfidenceWarnLoad,
  LowConfidenceWarnTuneClick,
  LowConfidenceLooksGoodClick
} from 'src/constants/trackingEvents'
import { handleAcknowledgeTuneValue } from 'src/actions/homeowner'

import { Button, Text, If, Unless } from 'src/Components'
import {
  IconThumbsUp,
  IconThumbsDown,
  IconWrench
} from 'src/Components/shared/Icon'
import WarningLayout from './WarningLayout'

import styles from './Warnings.module.scss'

const LowConfidenceWarning = ({ onNavigate }) => {
  const dispatch = useDispatch()

  const [thumbDown, setThumbDown] = useState(false)

  useEffect(() => {
    dispatchEvent(LowConfidenceWarnLoad)
  }, [])

  const handleClickCurry = action => {
    return () => {
      dispatchEvent(LowConfidenceLooksGoodClick)
      dispatch(action())
    }
  }

  const handleNavigate = () => {
    dispatchEvent(LowConfidenceWarnTuneClick)
    onNavigate()
  }

  return (
    <WarningLayout type={thumbDown ? 'error' : 'positive'} quizzical={false}>
      <Text
        element='div'
        color='white'
        align='left'
        className={styles.calloutMessage}
      >
        <Unless condition={thumbDown}>
          <FormattedMessage
            id='Homeowner.estimatedValue.lowConfidenceWarning'
            defaultMessage='Quick check: Does your value seem right?'
          />
        </Unless>
        <If condition={thumbDown}>
          <FormattedMessage
            id='Homeowner.estimatedValue.lowConfidenceWarning.thumbDown'
            defaultMessage='No worries - let’s change it together!'
          />
        </If>
      </Text>
      <Button.Group>
        <Unless condition={thumbDown}>
          <Button
            iconStart={IconThumbsUp}
            onClick={handleClickCurry(handleAcknowledgeTuneValue)}
          />
          <Button
            iconStart={IconThumbsDown}
            onClick={() => setThumbDown(true)}
          />
        </Unless>
        <If condition={thumbDown}>
          <Button iconStart={IconWrench} onClick={handleNavigate}>
            <FormattedMessage
              id='Homeowner.estimatedValue.lowConfidenceWarning.tune'
              defaultMessage='Tune'
            />
          </Button>
        </If>
      </Button.Group>
    </WarningLayout>
  )
}

export default LowConfidenceWarning
